// extracted by mini-css-extract-plugin
export var animationAbsolute = "_1a-o";
export var animationRelative = "_1a-n";
export var backdropBlur = "_1a-0";
export var detailLabelCell = "_1a-10";
export var detailTable = "_1a-z";
export var detailValueCell = "_1a-11";
export var docIconBox = "_1a-19";
export var docTypeRow = "_1a-14";
export var docTypeRowInner = "_1a-15";
export var dropdownMatchDatePicker = "_1a-1";
export var fileUploadSpin = "_1a-h";
export var gorgiasOpenButton = "_1a-13 _1a-b";
export var gorgiasTicketCard = "_1a-12";
export var heroModalFooterButton = "_1a-16";
export var hiddenContainer = "_1a-m";
export var maxWidthContainer = "_1a-17";
export var modalContentBody = "_1a-8";
export var modalHeaderImage = "_1a-3";
export var modalImageLabel = "_1a-5";
export var modalImageOverlay = "_1a-4";
export var modalImageSubtitle = "_1a-7";
export var modalImageTitle = "_1a-6";
export var modalImageWrapper = "_1a-2";
export var modalStickyFooter = "_1a-9";
export var removeButton = "_1a-c";
export var sidebarColumn = "_1a-18";
export var spinner = "_1a-g";
export var timelineLine = "_1a-w";
export var timelineLineBlack = "_1a-y _1a-w";
export var timelineLineGray = "_1a-x _1a-w";
export var timelineLineHeight = "_1a-v";
export var tlDotActivate = "_1a-s";
export var tlDotActivateAnim = "_1a-r";
export var tlDotHide = "_1a-q";
export var tlDotHideAnim = "_1a-p";
export var tlLineActivate = "_1a-u";
export var tlLineActivateAnim = "_1a-t";
export var uploadHint = "_1a-l";
export var uploadIconBox = "_1a-i";
export var uploadLabel = "_1a-k";
export var uploadText = "_1a-j";
export var uploadZone = "_1a-d";
export var uploadZoneCursorDefault = "_1a-f";
export var uploadZoneCursorPointer = "_1a-e";
export var uploadedFileRow = "_1a-a";
export var viewButton = "_1a-b";